import { CapaErrorCode, Output } from '@generated/graphql';
import { graphql } from 'msw';

export const updateIdentityCertification = graphql.mutation<Output>(
  'updateIdentityCertification',
  (req, res, ctx) => {
    return res(
      ctx.data({
        result: CapaErrorCode.Success,
        errorMessage: null,
        __typename: 'Output'
      })
    );
  }
);
